import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { AuthService } from "../services/service.index";
import Swal from "sweetalert2";

declare function init_plugins(): any;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit, OnDestroy {
  errorwarning: boolean;
  checkbox: boolean;
  errorMessage: string;

  constructor(private router: Router, private auth: AuthService) {}

  ngOnInit() {
    init_plugins();
    if (this.auth.isLoggedIn) {
      this.router.navigate(["/home"]);
    }
  }

  ngOnDestroy() {
    Swal.close();
  }

  onLogin(form: NgForm) {
    if (form.value.email == null || form.value.password == null) {
      this.errorMessage = "";
      this.errorwarning = true;
      return;
    }
    this.errorMessage = null;
    Swal.fire({
      title: "Ingresando a la plataforma!",
      html: "Espere unos segundos...",
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });
    this.auth
      .signIn(form.value.email, form.value.password)
      .then(() => {})
      .catch((err) => {
        Swal.close();
        this.errorwarning = true;
        this.errorMessage =
          "El correo electrónico ingresado no es administrador";
      })
      .finally(() => {
        Swal.close();
      });
  }

  setMyStyle() {
    let styles = {
      " background": "rgb(49,47,96)",
      background:
        "linear-gradient(145deg, rgba(49,47,96,1) 0%, rgba(42,41,59,1) 100%)",
      "background-repeat": "no-repeat",
    };
    return styles;
  }
}
